import { Options, Vue } from "vue-class-component";

@Options({
    name: "app-serial-number",
})
export default class SerialNumber extends Vue {
    public mounted() {
        console.log("请使用微信扫一扫，扫描此二维码！");
    }
}
